import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Image, Platform, ScrollView, StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import Colors from '../../constants/Colors';
import Languages from '../../constants/Languages';
import Layout from '../../constants/Layout';
import * as Actions from '../../store/Actions';
import Header from '../../components/register/Header';
import FilledButton from '../../components/FilledButton';
import getInstallationIdAsync from '../../utils/getInstallationIdAsync';
import { log } from '../../utils/logger';

import { AppText } from '../../components/AppText';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.mediumBlue,
  },
  mainContentContainer: {
    flex: 1,
    alignItems: 'center',
    backgroundColor: Colors.white,
  },
  topContainer: {
    flex: 1,
    alignItems: 'center',
  },
  headingText: {
    fontSize: Layout.isSmall ? 20 : 26,
    fontWeight: '500',
    color: Colors.veryDarkGray,
    fontFamily: 'roboto-regular',
    textAlign: 'center',
    marginTop: Layout.isSmall ? 53 : 34,
  },
  text: {
    fontFamily: 'roboto-regular',
    fontSize: Layout.isSmall ? 14 : 16,
    color: Colors.veryDarkGray,
    textAlign: 'center',
    marginTop: 8,
    width: 328,
  },
  image: {
    height: 101,
    width: 69,
    resizeMode: 'contain',
    marginTop: Layout.isSmall ? 33 : 79,
    marginLeft: -10,
  },
  signupContainer: Layout.signupContainer,
  signupFooter: Layout.signupFooter,
});

class EmailVerifiedScreen extends Component {
  static propTypes = {
    registration: PropTypes.objectOf(PropTypes.any).isRequired,
    actions: PropTypes.objectOf(PropTypes.any).isRequired,
    navigation: PropTypes.objectOf(PropTypes.any).isRequired,
    route: PropTypes.objectOf(PropTypes.any),
  };

  constructor(props) {
    super();
    this.state = {
      email: null,
    };
  }

  componentDidMount = async () => {
    const { actions, route } = this.props;

    log('EmailVerifiedScreen.componentDidMount: forwarding verification code', { platformOs: Platform.OS });
    let verificationCode;
    if (route?.params?.verification_code) {
      // Check navigation params first (mobile deep links)
      verificationCode = route.params.verification_code;
    } else if (Platform.OS === 'web') {
      // Fallback to URL params for web
      const params = new URL(document.location).searchParams;
      verificationCode = params.get('verification_code');
    }

    const deviceId = await getInstallationIdAsync();
    actions.emailVerified(verificationCode, deviceId);
  };

  componentDidUpdate = () => {
    const { registration } = this.props;
    const { email } = this.state;
    if (!email && registration.enterEmail.results.email) {
      this.setState({ email: registration.enterEmail.results.email });
    }
  };

  goBack = () => {
    const { navigation } = this.props;
    navigation.navigate('Language');
  };

  goNext = () => {
    const { navigation, registration } = this.props;
    const { enterEmail } = registration;
    if (enterEmail.results.has_password) {
      navigation.navigate('PhoneOrEmail');
    } else {
      navigation.navigate('CreatePassword');
    }
  };

  render() {
    const { registration } = this.props;
    const { email } = this.state;
    const { language } = registration;
    const translation = Languages.translations[language?.name || 'en'];

    return (
      <SafeAreaView style={{ flex: 1 }} edges={['top', 'left', 'right', 'bottom']}>
        <ScrollView
          keyboardShouldPersistTaps="handled"
          contentContainerStyle={styles.mainContentContainer}
          style={styles.container}
          testID="email-verified"
        >
          <Header title={translation.email_verified} goBack={this.goBack} />
          <View style={styles.signupContainer}>
            <View style={styles.topContainer}>
              <Image source={require('../../assets/images/sign_up/image_36.png')} style={styles.image} />
              <AppText style={styles.headingText}>{translation.email_verified}</AppText>
              <AppText style={styles.text}>{translation.email_verified_details}</AppText>
            </View>
            <View style={styles.signupFooter}>
              <FilledButton
                onPress={this.goNext}
                label={translation.continue}
                color={Colors.primaryColor}
                full
                textColor={Colors.white}
                disabled={!email}
                testID="button-continue"
              />
            </View>
          </View>
        </ScrollView>
      </SafeAreaView>
    );
  }
}

function mapStateToProps(state) {
  return {
    registration: state.registration,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailVerifiedScreen);
